import { render, staticRenderFns } from "./ProspectMapTab.vue?vue&type=template&id=0cfa72e8"
import script from "./ProspectMapTab.vue?vue&type=script&lang=js"
export * from "./ProspectMapTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports